import { createContext } from 'react';

export const PublishLayoutContext = createContext(
    {
        "hasLayout":false
    }
);